<template>
  <div class="page-block" :class="{ fullPage, transparentBg }">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  fullPage?: boolean;
  transparentBg?: boolean;
}>();

defineSlots<{
  default: (props: unknown) => void;
}>();
</script>

<style scoped lang="scss">
.page-block {
  display: flex;
  flex-direction: column;

  padding: 24px;

  background-color: $main-bg-color;
  border-radius: $border-radius-xl;

  &.fullPage {
    flex-grow: 1;
  }

  &.transparentBg {
    padding: 0;

    background-color: transparent;

    @include md-and-down {
      padding: 0 $gap-5 $gap-5;
    }
  }

  @include xs {
    padding: 24px 16px;

    border-radius: $border-radius-xl;

    &.transparentBg {
      padding: 0 16px 16px;
    }
  }
}
</style>
